import { render, staticRenderFns } from "./LeadVC.vue?vue&type=template&id=3410920c"
import script from "./LeadVC.vue?vue&type=script&lang=js"
export * from "./LeadVC.vue?vue&type=script&lang=js"
import style0 from "./LeadVC.vue?vue&type=style&index=0&id=3410920c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports